import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BlogService } from '../blog.service';
import { DetailBlogPost } from '../blog.types';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export const blogPostResolver: ResolveFn<DetailBlogPost | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const blogService = inject(BlogService);
  const sanitizer = inject(DomSanitizer);
  
  // Extract the blog post URL from the route parameters
  const category = route.paramMap.get('category');
  const title = route.paramMap.get('title');
  
  if (!category || !title) {
    return of(null);
  }
  
  const blogPostUrl = `${category}/${title}`;
  
  return blogService.getById(blogPostUrl).pipe(
    map(response => {
      if (response.data) {
        return {
          ...response.data,
          // Sanitize HTML content for SSR
          content: sanitizer.bypassSecurityTrustHtml(response.data.content ?? ''),
          featuredProducts: response.data.featuredProducts.map((x: any) => ({ 
            content: { product: x }
          })),
          publishDate: response.data.publishDate
        } as DetailBlogPost;
      }
      return null;
    }),
    catchError(error => {
      console.error('Error loading blog post:', error);
      return of(null);
    })
  );
};
